import {apiClient} from 'core/apiClient';
import {Participant} from 'types/participants';
import {StaffListRawRow, StaffListRequest, StaffPaginationContent} from 'types/profile';

const URL = 'uaa/web';

export async function fetchPagedStaffList(
    params: StaffListRequest,
): Promise<StaffPaginationContent<StaffListRawRow>> {
    return (
        await apiClient.post<StaffPaginationContent<StaffListRawRow>>(
            `${URL}/employees/paged`,
            params,
        )
    ).data;
}

export async function fetchStaffList(): Promise<StaffListRawRow[]> {
    return (await apiClient.get<StaffListRawRow[]>(`${URL}/employees`)).data;
}

export async function fetchParticipantList() {
    return (await apiClient.get<Participant[]>(`uaa/clients`)).data;
}
